module.exports = __webpack_public_path__ + "fonts/Helios-bold.3ceee31b.eot";